import { render, staticRenderFns } from "./Publication_list.vue?vue&type=template&id=4167d1b1&scoped=true&"
import script from "./Publication_list.vue?vue&type=script&lang=js&"
export * from "./Publication_list.vue?vue&type=script&lang=js&"
import style0 from "./Publication_list.vue?vue&type=style&index=0&id=4167d1b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4167d1b1",
  null
  
)

export default component.exports